import React from "react";
import "../styles/Contact.css";
import { FaLinkedin, FaGithub, FaEnvelope, FaGlobe } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export default function Contact() {
  const { t } = useTranslation();

  return (
    <div className="contact">
      <h1>{t('contact.title')}</h1>

      <p>{t('contact.description1')}</p>
      <p>{t('contact.description2')}</p>

      <div className="contact-links">

        <a href="mailto:contact@zeldle.xyz" className="contact-item">
          <FaEnvelope size={24} />
          <span>contact@zeldle.xyz</span>
        </a>

        <a href="https://www.linkedin.com/in/pierre-derniame/" target="_blank" rel="noopener noreferrer" className="contact-item contact-linkedin">
          <FaLinkedin size={24} />
          <span>Pierre Derniame</span>
        </a>

        <a href="https://github.com/lempreurs-lps" target="_blank" rel="noopener noreferrer" className="contact-item contact-github">
          <FaGithub size={24} />
          <span>lempreurs-lps</span>
        </a>

        <a href="https://lps-consulting.fr" target="_blank" rel="noopener noreferrer" className="contact-item contact-website">
          <FaGlobe size={24} />
          <span>lps-consulting.fr</span>
        </a>

      </div>

      <p className="contact-response">{t('contact.response')}</p>
    </div>
  );
}